import { getTypedState } from 'ducks/hooks'
import { Property } from 'ducks/types'

export const getProperties = () => (): Property[] => {
  const { properties } = getTypedState()
  if (!properties || !properties.length) return []
  return properties
}

export const getPropertyById = (id: string) => (): Property => {
  const { properties } = getTypedState()
  return properties.find((prop) => prop.id === id) as Property
}
